import {
    createContext,
    useCallback,
    useMemo,
    useState,
    type PropsWithChildren,
} from "react";
import type { ActiveMenuState, MenuContextType } from "../../types/MenuContextType";

export const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const MenuProvider = ({ children }: PropsWithChildren) => {
    const [activeMenu, setActiveMenu] = useState<ActiveMenuState>({ id: undefined, x: 0, y: 0 });

    const handleCloseMenu = useCallback(() => {
        activeMenu?.setTooltipOpen?.(false);
        setActiveMenu({ id: undefined, x: 0, y: 0 });
    }, [activeMenu]);

    const value: MenuContextType = useMemo(() => {
        return {
            ...activeMenu,
            openMenu: setActiveMenu,
            closeMenu: handleCloseMenu
        };
    }, [activeMenu, handleCloseMenu]);

    return (
        <MenuContext.Provider value={value}>
            {children}
        </MenuContext.Provider>
    );
}